import React from "react";
import GitHubCalendar from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <p style={{ textAlign: "center", maxWidth: "600px", marginBottom: "10px", color: "#888" }}>
        *Disclaimer: I haven’t pushed much to GitHub yet — I’ve mostly worked outside of it. But that’s changing soon!
      </p>
      <h1 className="project-heading" style={{ paddingBottom: "20px" }}>
        Days I <strong className="purple">Code</strong>
      </h1>
      <GitHubCalendar
        username="ahmadsmohammad"
        blockSize={15}
        blockMargin={5}
        color="#c084f5"
        fontSize={16}
      />
    </Row>
  );
}

export default Github;
